<template>
  <div class="screening-progress-insights-tab">
    <screening-progress-card
      :review="review"
      :current-researcher="currentResearcher"
    />
  </div>
</template>

<script>
import ScreeningProgressCard from './ScreeningProgressCard';
import { Review, Researcher } from '@/models';

export default {
  name: 'ScreeningProgressInsightsTab',
  components: {
    ScreeningProgressCard,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.screening-progress-insights-tab {
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(0, 1300px);
  justify-content: center;

  width: 100%;
}
</style>
